import styled from 'styled-components';
import DropdownHeading from '../Dropdown/DropdownHeading';
/**
 * The [`Menu`](#/Dialog%20components?id=menu) component is usually limited to a list
 * of [`MenuItem`](#/Dialog%20components?id=menuitem) actions, but you can add a heading
 * with this component.
 *
 * @since 8.61.0
 */

var MenuHeading = /*#__PURE__*/styled(DropdownHeading).withConfig({
  displayName: "MenuHeading",
  componentId: "c11n-8-64-0__sc-g7x6oa-0"
})([""]);
/** @component */

export default MenuHeading;